/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDeliverFeeInternationalListRespVo
 */
export interface GetDeliverFeeInternationalListRespVo {
    /**
     * 仓库id
     * @type {number}
     * @memberof GetDeliverFeeInternationalListRespVo
     */
    warehouseId?: number;
    /**
     * 运输方式id
     * @type {number}
     * @memberof GetDeliverFeeInternationalListRespVo
     */
    transportMethodId?: number;
    /**
     * 国际运费分组：1电商快递，2海运物流，3橙火服务，4韩国3PL
     * @type {number}
     * @memberof GetDeliverFeeInternationalListRespVo
     */
    orderTypeGroup?: number;
    /**
     * 用户等级id
     * @type {number}
     * @memberof GetDeliverFeeInternationalListRespVo
     */
    gradeId?: number;
    /**
     * 用户等级名称
     * @type {string}
     * @memberof GetDeliverFeeInternationalListRespVo
     */
    gradeName?: string;
    /**
     * 计费标准1 重量， 2 cbm， 3 区间值
     * @type {number}
     * @memberof GetDeliverFeeInternationalListRespVo
     */
    chargeStandard?: number;
    /**
     * 起始值：重量(kg)或CBM
     * @type {number}
     * @memberof GetDeliverFeeInternationalListRespVo
     */
    startValue?: number;
    /**
     * 结束值
     * @type {number}
     * @memberof GetDeliverFeeInternationalListRespVo
     */
    endValue?: number;
    /**
     * 步长
     * @type {number}
     * @memberof GetDeliverFeeInternationalListRespVo
     */
    stepValue?: number;
    /**
     * 起始金额
     * @type {number}
     * @memberof GetDeliverFeeInternationalListRespVo
     */
    startAmount?: number;
    /**
     * 每步递增金额
     * @type {number}
     * @memberof GetDeliverFeeInternationalListRespVo
     */
    stepAmount?: number;
}

/**
 * Check if a given object implements the GetDeliverFeeInternationalListRespVo interface.
 */
export function instanceOfGetDeliverFeeInternationalListRespVo(value: object): value is GetDeliverFeeInternationalListRespVo {
    return true;
}

export function GetDeliverFeeInternationalListRespVoFromJSON(json: any): GetDeliverFeeInternationalListRespVo {
    return GetDeliverFeeInternationalListRespVoFromJSONTyped(json, false);
}

export function GetDeliverFeeInternationalListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliverFeeInternationalListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'transportMethodId': json['transportMethodId'] == null ? undefined : json['transportMethodId'],
        'orderTypeGroup': json['orderTypeGroup'] == null ? undefined : json['orderTypeGroup'],
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'gradeName': json['gradeName'] == null ? undefined : json['gradeName'],
        'chargeStandard': json['chargeStandard'] == null ? undefined : json['chargeStandard'],
        'startValue': json['startValue'] == null ? undefined : json['startValue'],
        'endValue': json['endValue'] == null ? undefined : json['endValue'],
        'stepValue': json['stepValue'] == null ? undefined : json['stepValue'],
        'startAmount': json['startAmount'] == null ? undefined : json['startAmount'],
        'stepAmount': json['stepAmount'] == null ? undefined : json['stepAmount'],
    };
}

export function GetDeliverFeeInternationalListRespVoToJSON(json: any): GetDeliverFeeInternationalListRespVo {
    return GetDeliverFeeInternationalListRespVoToJSONTyped(json, false);
}

export function GetDeliverFeeInternationalListRespVoToJSONTyped(value?: GetDeliverFeeInternationalListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseId': value['warehouseId'],
        'transportMethodId': value['transportMethodId'],
        'orderTypeGroup': value['orderTypeGroup'],
        'gradeId': value['gradeId'],
        'gradeName': value['gradeName'],
        'chargeStandard': value['chargeStandard'],
        'startValue': value['startValue'],
        'endValue': value['endValue'],
        'stepValue': value['stepValue'],
        'startAmount': value['startAmount'],
        'stepAmount': value['stepAmount'],
    };
}

